"use strict";

module.exports = {
  logo_upload_path: "test-uploaded-files",
  uploaded_fintech_invoice_file_path: "uploaded_fintech_invoice",
  bodyLimit: "100kb",
  corsHeaders: ["Link", "Content-Disposition"],
  redis: {
    host: process.env.REDIS_HOST || "127.0.0.1",
    port: process.env.REDIS_PORT || "6379"
  },
  // keep the tokens alive for 23h
  jwt_expiration: "23h",
  // customer users keep longer sessions so their persisted carts survive between visits
  customer_jwt_expiration: "96h",
  jwt_encryption: "aasdfasdf sdf adsf",
  admin_token_secret: process.env.ADMIN_TOKEN_SECRET || "admin_token_secret_key_change_in_production",
  admin_auth_token: process.env.ADMIN_AUTH_TOKEN,
  pdf_path: "/temp/pdf",
  s3: {
    bucket: "ynvoice-test123",
    access: {
      region: "",
      secretAccessKey: "",
      accessKeyId: ""
    }
  }
};